import apiClient from './apiClient'

export const createPayment = async (orderId) => {
  const response = await apiClient.post('/payments/create/', { order_id: orderId })
  return response.data
}

export const getPaymentStatus = async (orderId) => {
  const response = await apiClient.get(`/payments/status/${orderId}/`)
  return response.data
}

export const checkMercadoPagoStatus = async (orderId) => {
  const response = await apiClient.post('/payments/check-status/', { order_id: orderId })
  return response.data
}

export const refundPayment = async (orderId) => {
  const response = await apiClient.post('/payments/refund/', { order_id: orderId })
  return response.data
}

export const getMercadoPagoConfig = async () => {
  const response = await apiClient.get('/payments/config/')
  return response.data
}
